import { render, staticRenderFns } from "./epms2020_waste.vue?vue&type=template&id=df0f5092&scoped=true"
import script from "./epms2020_waste.vue?vue&type=script&lang=js"
export * from "./epms2020_waste.vue?vue&type=script&lang=js"
import style0 from "./epms2020_waste.vue?vue&type=style&index=0&id=df0f5092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0f5092",
  null
  
)

export default component.exports